<script lang="ts">
  import type { Snippet } from 'svelte';
  let { children, class: className = '' }: { children: Snippet; class?: string } = $props();
</script>

<kbd class="kbd {className}">
  {@render children()}
</kbd>

<style>
  .kbd {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    padding: 0 var(--space-2);
    font-family: var(--font-mono);
    font-size: 0.7rem;
    font-weight: var(--weight-semibold);
    line-height: 1;
    color: var(--color-text-secondary);
    background: var(--color-surface-sunken);
    border: var(--border-width) solid var(--color-border);
    border-bottom-width: 2px;
    border-radius: var(--radius-sm);
  }
</style>